export default "__VITE_ASSET__BpbgtU7G__"